// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_chevron__53SDc.styles_right__nF19M {
  margin-right: 0.5rem; }
  .styles_chevron__53SDc.styles_right__nF19M::after {
    font-size: 1.2rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/DirectionalActions/styles.module.scss"],"names":[],"mappings":"AAAA;EAEI,oBAAoB,EAAA;EAFxB;IAIM,iBAAiB,EAAA","sourcesContent":[".chevron {\n  &.right {\n    margin-right: 0.5rem;\n    &::after {\n      font-size: 1.2rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chevron": `styles_chevron__53SDc`,
	"right": `styles_right__nF19M`
};
export default ___CSS_LOADER_EXPORT___;
